<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 88px">
      <Loading></Loading>
    </div>
    <div v-else>
      <div
        class="profilebg"
        :style="{
          'background-image':
            'url(' +
            (data.dealer_info.profile_cover
              ? data.dealer_info.profile_cover
              : require('../../assets/bluebg.jpg')) +
            ')',
        }"
      >
        <!-- xx -->
        <div style="position: absolute; right: 10px; top: 10px">
          <v-btn
            dark
            :loading="imgCoverLoading"
            @click="$refs.uploadCover.onClickUploadFile()"
            icon
            small
          >
            <v-icon small style="color: white">mdi-square-edit-outline</v-icon>
          </v-btn>
        </div>
        <div>
          <div class="text-center pt-7 Kanit">
            <div
              style="
                position: relative;
                height: 125px;
                width: 125px;
                margin-left: auto;
                margin-right: auto;
              "
            >
              <img class="profileimg" :src="data.dealer_info.profile_pic" />

              <div
                v-if="imgLoading"
                style="
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                "
              >
                <v-progress-circular
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </div>
              <v-btn
                @click="$refs.uploadImg.onClickUploadFile()"
                class="editbutton"
                fab
                x-small
                color="primary"
              >
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </div>
            <div class="mt-3">
              <p style="margin-bottom: 3px; font-size: 24px; color: white">
                {{ data.dealer_info.name }}
              </p>
              <div>
                <div v-if="data.role.includes('ช่าง')">
                  <v-chip small>
                    <v-icon style="color: rgb(9 76 197)"
                      >mdi-format-paint</v-icon
                    >ช่างทาสี
                  </v-chip>
                </div>
                <div v-if="data.role.includes('ร้านค้า')">
                  <v-chip small>
                    <v-icon style="color: #d08600">mdi-store</v-icon>ร้านค้า
                  </v-chip>
                </div>
                <div v-if="data.role.includes('สถาปนิก')">
                  <v-chip small>
                    <v-icon style="color: rgb(0 156 84)">mdi-set-square</v-icon
                    >สถาปนิก
                  </v-chip>
                </div>
                <div v-if="data.role.includes('เจ้าของบ้าน')">
                  <v-chip small>
                    <v-icon style="color: rgb(197 9 9)">home</v-icon>เจ้าของบ้าน
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
          <div v-show="false">
            <uploadfile
              @startImgloading="startImgloading"
              ref="uploadImg"
              @input="onChangeImage"
              v-model="data.profile_pic"
            ></uploadfile>
            <uploadfile
              @startImgloading="startImgCoverloading"
              ref="uploadCover"
              @input="onChangeCoverImage"
              v-model="data.profile_cover"
            ></uploadfile>
          </div>
        </div>
        <div class="radiusfake"></div>
      </div>
      <div class="contentpad Kanit">
        <v-container style="position: relative; top: -17px" class="px-6 pt-0">
          <v-list dense>
            <template>
              <v-list-item @click="active = !active">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #f5c644"
                          >mdi-format-list-checkbox</v-icon
                        >
                      </span>
                      <span class="menufont">สถานะออเดอร์</span>
                    </div>
                    <div>
                      <v-icon v-if="active">mdi-chevron-down</v-icon>
                      <v-icon v-else>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>
              <div v-if="active">
                <div
                  style="
                    display: flex;
                    justify-content: space-evenly;
                    margin-top: 30px;
                    margin-bottom: 25px;
                  "
                >
                  <div v-ripple class="pa-2" style="border-radius: 10px">
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.wait_to_pay && false
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="bigiconsize"
                          >mdi-text-box-search-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.wait_to_pay && false"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.wait_to_pay }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center ordericonfont"
                      :style="`color: ${
                        data.orderstatus.wait_to_pay ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      รอประเมินราคา
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog(
                        'รอการชำระเงิน',
                        data.orderstatus.wait_to_pay
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.wait_to_pay
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="bigiconsize"
                          >mdi-wallet-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.wait_to_pay"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.wait_to_pay }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center ordericonfont"
                      :style="`color: ${
                        data.orderstatus.wait_to_pay ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      รอการชำระเงิน
                    </div>
                  </div>
                  <div
                    @click="
                      showOrdersDialog(
                        'รอการจัดส่ง',
                        data.orderstatus.wait_to_ship
                      )
                    "
                    v-ripple
                    class="pa-2"
                    style="border-radius: 10px"
                  >
                    <div class="text-center">
                      <span class="ordericon">
                        <v-icon
                          :style="`color: ${
                            data.orderstatus.wait_to_ship
                              ? '#0a4ea2'
                              : 'darkgrey'
                          }`"
                          class="bigiconsize"
                          >mdi-truck-delivery-outline</v-icon
                        >
                        <div
                          v-if="data.orderstatus.wait_to_ship"
                          class="numbericon"
                        >
                          <div>{{ data.orderstatus.wait_to_ship }}</div>
                        </div>
                      </span>
                    </div>
                    <div
                      class="mt-2 text-center ordericonfont"
                      :style="`color: ${
                        data.orderstatus.wait_to_ship ? '#0a4ea2' : 'darkgrey'
                      }`"
                    >
                      รอการจัดส่ง
                    </div>
                  </div>
                </div>
              </div>

              <v-list-item @click="changeView('ShippingCar')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #72df72"
                          >mdi-truck-fast-outline</v-icon
                        >
                      </span>
                      <span class="menufont">เรียกรถรับสินค้า</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item
                @click="
                  showOrdersDialog('updateprogress', data.orderstatus.contact)
                "
              >
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #73da73"
                          >mdi-progress-check</v-icon
                        >
                      </span>
                      <span class="menufont">อัพเดทงานลูกค้า</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('DealerAddress')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: green"
                          >mdi-home-map-marker</v-icon
                        >
                      </span>
                      <span class="menufont">ที่อยู่ของฉัน</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="myaccountactive = !myaccountactive">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #657fff"
                          >account_balance</v-icon
                        >
                      </span>
                      <span class="menufont">บัญชีของฉัน</span>
                    </div>
                    <div>
                      <v-icon v-if="myaccountactive">mdi-chevron-down</v-icon>
                      <v-icon v-else>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div v-if="myaccountactive" class="px-3">
                <div v-if="!bankEdit">
                  <v-btn
                    @click="bankEdit = true"
                    small
                    text
                    icon
                    style="float: right"
                  >
                    <v-icon small>mdi-square-edit-outline</v-icon>
                  </v-btn>
                  <div class="banklabel">ชื่อธนาคาร</div>
                  <div class="bankinfo">
                    {{
                      data.dealer_info.bankname
                        ? data.dealer_info.bankname
                        : "-"
                    }}
                  </div>
                  <div class="banklabel">ชื่อบัญชี</div>
                  <div class="bankinfo">
                    {{
                      data.dealer_info.bank_account_name
                        ? data.dealer_info.bank_account_name
                        : "-"
                    }}
                  </div>
                  <div class="banklabel">เลขบัญชี</div>
                  <div class="bankinfo">
                    {{
                      data.dealer_info.bank_account_number
                        ? data.dealer_info.bank_account_number
                        : "-"
                    }}
                  </div>
                </div>
                <div v-else>
                  <ValidationObserver
                    ref="observer"
                    v-slot="{ handleSubmit }"
                    tag="form"
                  >
                    <form @submit.prevent="handleSubmit(editBank)">
                      <ValidationProvider
                        :name="'ชื่อธนาคาร'"
                        key="ชื่อธนาคาร"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="banklabel">ชื่อธนาคาร</div>
                        <v-select
                          :items="allbanks"
                          v-model="bankinput.bankname"
                          :error-messages="errors"
                          outlined
                          dense
                          autocomplete
                        ></v-select>
                      </ValidationProvider>
                      <ValidationProvider
                        :name="'ชื่อเจ้าของบัญชี'"
                        key="ชื่อเจ้าของบัญชี"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="banklabel">ชื่อเจ้าของบัญชี</div>
                        <v-text-field
                          dense
                          outlined
                          :error-messages="errors"
                          @input="
                            bankinput.bank_account_name = removeHiddenSpace(
                              $event
                            )
                          "
                          v-model="bankinput.bank_account_name"
                        ></v-text-field>
                      </ValidationProvider>
                      <ValidationProvider
                        :name="'เลชบัญชี'"
                        key="เลขบัญชี"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <div class="banklabel">เลขบัญชี</div>
                        <v-text-field
                          dense
                          outlined
                          :error-messages="errors"
                          @input="
                            bankinput.bank_account_number = removeHiddenSpace(
                              $event
                            )
                          "
                          v-model="bankinput.bank_account_number"
                        ></v-text-field>
                      </ValidationProvider>
                      <div class="text-center">
                        <v-btn
                          :loading="bankloading"
                          type="submit"
                          class="mr-1"
                          color="primary"
                          >บันทึก</v-btn
                        >
                        <v-btn @click="cancelBank" color="grey" outlined
                          >ยกเลิก</v-btn
                        >
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
              <v-divider></v-divider>
              <v-list-item
                @click="goToUrl('https://controls.paysolutions.asia/en/authen')"
                v-if="!paysolutionurlisEdit"
              >
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <img
                          style="height: 50%; width: 64px"
                          src="../../assets/paysolutionlogo.png"
                        />
                      </span>
                      <span class="menufont">Pay solutions</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item
                @click="goToUrl('https://app.fillgoods.co/login')"
                v-if="!fillgoodurlisEdit"
              >
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <img
                          style="height: 50%; width: 64px"
                          src="../../assets/fillgoodslogo.png"
                        />
                      </span>
                      <span class="menufont">Fill Goods</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-bell-outline</v-icon
                        >
                      </span>
                      <span class="menufont" style="color: rgb(179 179 179)"
                        >แจ้งเตือน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: rgb(179 179 179)"
                          >mdi-history</v-icon
                        >
                      </span>
                      <span class="menufont" style="color: rgb(179 179 179)"
                        >ประวัติการใช้งาน</span
                      >
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="changeView('ForgetPassword')">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: #05a3ff"
                          >mdi-shield-key-outline</v-icon
                        >
                      </span>
                      <span class="menufont">รหัสผ่าน / เปลี่ยนรหัสผ่าน</span>
                    </div>
                    <div>
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="logout">
                <v-list-item-content class="py-0">
                  <div class="flexcontainer">
                    <div>
                      <span class="mr-4">
                        <v-icon class="iconmenu" style="color: black"
                          >mdi-logout</v-icon
                        >
                      </span>
                      <span class="menufont">ออกจากระบบ</span>
                    </div>
                    <div style="color: darkgrey">
                      <v-icon>mdi-chevron-right</v-icon>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-list>
        </v-container>
      </div>
      <div>
        <v-dialog v-model="showorders" persistent fullscreen>
          <v-card>
            <v-card-text v-if="showorders">
              <div class="text-right pa-4">
                <v-btn @click="showorders = false" icon small>
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
              <div v-if="activeorder == 'updateprogress'">
                <UpdateProgress v-model="data"></UpdateProgress>
              </div>
              <OrderList
                v-else
                :title="activeorder"
                :user="data"
                :orders="orderlist"
              ></OrderList>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import OrderList from "../OrderList.vue";
import uploadfile from "@/components/UploadSingleFile.vue";
// var banksLogo = require('banks-logo');
import banksLogo from "banks-logo";
import collect from "collect.js";
import UpdateProgress from "./UpdateProgress.vue";
export default {
  data() {
    return {
      imgCoverLoading: false,
      loading: true,
      showorders: false,
      active: true,
      activeorder: "",
      imgLoading: false,
      paysolutionurlactive: false,
      paysolutionurlisEdit: false,
      paysolutionurl: "",
      paysolutionloading: false,
      fillgoodloading: false,
      fillgoodurlactive: false,
      fillgoodurlisEdit: false,
      fillgoodurl: "",
      myaccountactive: false,
      bankEdit: false,
      bankinput: {
        bankname: "",
        bank_account_name: "",
        bank_account_number: "",
        bank_account_image: "",
      },
      allbanks: [],
      bankloading: false,
    };
  },
  components: {
    Loading,
    OrderList,
    uploadfile,
    UpdateProgress,
  },
  computed: {
    data() {
      return this.$store.state.show;
    },
    profile() {
      return this.$store.state.profile;
    },
    query() {
      return this.$store.state.query;
    },
    orderlist() {
      if (this.activeorder) {
        return this.data.orderlist.filter(
          (el) => el.status == this.activeorder
        );
      } else return [];
    },
  },
  async mounted() {
    var vm = this;
    await this.checkLoginStatus();
    if (!this.data) {
      await this.getCustomerInfo();
    }
    vm.initInfo();
    var allbanks = collect(banksLogo.data).pluck("official_name_thai").all();
    for (const [key, value] of Object.entries(allbanks)) {
      this.allbanks.push(value);
    }

    this.loading = false;
  },
  methods: {
    goToUrl(url) {
      window.location.assign(url);
    },
    editBank() {
      this.bankloading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        bankname: this.bankinput.bankname, // ชื่อธนาคาร
        bank_account_name: this.bankinput.bank_account_name, // ชื่อ บช.
        bank_account_number: this.bankinput.bank_account_number, // เลข บช.
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toadealerupdatebankaccount",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          this.bankloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            this.bankEdit = false;
            // Object.assign(this.data.dealer_info, ...this.bankinput);
            this.data.dealer_info.bankname = this.bankinput.bankname;
            this.data.dealer_info.bank_account_name = this.bankinput.bank_account_name;
            this.data.dealer_info.bank_account_number = this.bankinput.bank_account_number;
            this.data.dealer_info.bank_account_image = this.bankinput.bank_account_image;
          }
        });
    },
    cancelBank() {
      this.bankEdit = false;
      this.bankinput.bankname = this.data.dealer_info.bankname;
      this.bankinput.bank_account_name = this.data.dealer_info.bank_account_name;
      this.bankinput.bank_account_number = this.data.dealer_info.bank_account_number;
      this.bankinput.bank_account_image = this.data.dealer_info.bank_account_image;
    },
    cancelFillgood() {
      this.fillgoodurlisEdit = false;
      this.fillgoodurl = this.data.dealer_info.fillgoodslink;
    },
    editFillgood() {
      this.fillgoodloading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        fillgoodslink: this.fillgoodurl, // ไม่ Require
        // paysolutionlink // ไม่ Require
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toaupdatelinkpaysolutionorfillgoods",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          this.fillgoodloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            this.fillgoodurlisEdit = false;
            this.data.dealer_info.fillgoodslink = this.fillgoodurl;
          }
        });
    },
    cancelPaysolution() {
      this.paysolutionurlisEdit = false;
      this.paysolutionurl = this.data.dealer_info.paysolutionlink;
    },
    editPaysolution() {
      this.paysolutionloading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        // fillgoodslink: this.fillgoodurl, // ไม่ Require
        paysolutionlink: this.paysolutionurl, // ไม่ Require
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toaupdatelinkpaysolutionorfillgoods",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          this.paysolutionloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          } else if (response.data.responsecode == 200) {
            this.paysolutionurlisEdit = false;
            this.data.dealer_info.paysolutionlink = this.paysolutionurl;
          }
        });
    },
    startImgloading() {
      this.imgLoading = !this.imgLoading;
    },
    startImgCoverloading() {
      this.imgCoverLoading = !this.imgCoverLoading;
    },
    onChangeImage() {
      this.imgLoading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        profile_pic: this.data.profile_pic,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toadealeruploadprofile",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgLoading = false;
        });
    },
    onChangeCoverImage() {
      this.imgCoverLoading = true;
      var data = {
        userid: this.$store.state.userid,
        apptype: this.query.apptype,
        pageid: this.query.pageid,
        profile_cover: this.data.profile_cover,
      };
      axios
        .put(
          "https://communitybotbyzwizai.herokuapp.com/toauploadprofilecover",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
            });
            return;
          }
          this.imgCoverLoading = false;
        });
    },
    showOrdersDialog(type, countnumber = 1) {
      if (countnumber) {
        this.activeorder = type;
        this.showorders = true;
      }
    },
    changeView(view) {
      this.$store.state.redirect = "DealerProfile";
      this.query.view = view;
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              this.$store.state.redirect = "CustomerProfile";
              this.query.view = "Agreement";
              resolve();
            } else {
              resolve();
            }
          });
      });
    },
    logout() {
      var vm = this;
      vm.$swal.fire({
        icon: "question",
        text: "ต้องการออกจากระบบใช่หรือไม่?",
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            var data = {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: vm.query.pageid,
            };
            axios
              .put(
                "https://communitybotbyzwizai.herokuapp.com/toalogoutusers",
                data,
                {
                  headers: { AUTHORIZATION: "Bearer xxx xxx" },
                }
              )
              .then(async (response) => {
                if (response.data && response.data.responsecode == 400) {
                  await this.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                  });
                  return;
                } else if (response.data.responsecode == 200) {
                  vm.$store.state.redirect = "CustomerProfile";
                  vm.query.view = "Login";
                  resolve();
                }
              });
          });
        },
      });
    },
    initInfo() {
      var vm = this;
      if (vm.data.dealer_info && vm.data.dealer_info.fillgoodslink) {
        vm.fillgoodurl = vm.data.dealer_info.fillgoodslink;
      }
      if (vm.data.dealer_info && vm.data.dealer_info.paysolutionlink) {
        vm.paysolutionurl = vm.data.dealer_info.paysolutionlink;
      }
      this.bankinput.bankname = this.data.dealer_info.bankname;
      this.bankinput.bank_account_name = this.data.dealer_info.bank_account_name;
      this.bankinput.bank_account_number = this.data.dealer_info.bank_account_number;
      this.bankinput.bank_account_image = this.data.dealer_info.bank_account_image;
    },
    getCustomerInfo() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealerpersonalinfo",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: vm.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              vm.$store.state.show = response.data.data[0];

              resolve();
            } else {
              vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss">
.radiusfake {
  background-color: white;
  height: 30px;
  width: 100%;
  border-radius: 20px 20px 0px 0px;
  position: absolute;
  bottom: -2px;
  left: 0px;
}
.profilebg {
  // background-image: url("../assets/bluebg.jpg");
  background-size: cover;
  padding-bottom: 50px;
  position: relative;
}
.profileimg {
  height: 100%;
  width: 100%;
  border-radius: 99px;

  border: 5px white solid;
}
.editbutton {
  position: absolute;
  right: 0px;
  bottom: 0px;
}
.contentpad {
  width: 100%;
  background-color: white;
}
.menufont {
  color: #0a4ea2;
  font-size: 13px;
}
.iconmenu {
  font-size: 23px !important;
}
.flexcontainer {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.ordericon {
  position: relative;
}
.numbericon {
  width: 21px;
  height: 21px;
  display: flex;
  align-items: center;
  position: absolute;
  justify-content: center;
  border-radius: 99px;
  color: white;
  background-color: #d10a0a;
  top: -11px;
  left: -7px;
}
.ordericonfont {
  font-size: 13px;
}
.bankinfo {
  color: black;
  font-size: 18px;
}
.banklabel {
  font-size: 12px;
}
.bigiconsize {
  font-size: 30px !important;
}
</style>